import { ProvinceCreatePage } from "@/features/geolocation/page/ProvinceCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/province/create")({
  component: ProvinceCreatePage,
});
